export const GET_PRODUCT_INFORMATIONS = 'GET_PRODUCT_INFORMATIONS'

export const GET_CURRENT_PRODUCT = 'GET_CURRENT_PRODUCT'

export const GET_OPEN_PRODUCT = 'GET_OPEN_PRODUCT'

export const GET_ADD_TO_CART_BUTTON_STATE = 'GET_ADD_TO_CART_BUTTON_STATE'

export const GET_TRAD = 'GET_TRAD'